import { render, staticRenderFns } from "./EditFilePage.vue?vue&type=template&id=78a25d4c&"
import script from "./EditFilePage.vue?vue&type=script&lang=js&"
export * from "./EditFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports